import { render, staticRenderFns } from "./ActionRemoveShippingMethod.vue?vue&type=template&id=2f650d91&scoped=true"
import script from "./ActionRemoveShippingMethod.vue?vue&type=script&lang=js"
export * from "./ActionRemoveShippingMethod.vue?vue&type=script&lang=js"
import style0 from "./ActionRemoveShippingMethod.vue?vue&type=style&index=0&id=2f650d91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f650d91",
  null
  
)

export default component.exports